import Component from '../../components/component/component';
import Helpers from '../../components/helpers/helpers';

import 'slick-carousel';

import 'slick-carousel/slick/slick.scss';
import './blog-carousel.scss';

export default class BlogCarousel extends Component {
    static initSelector: string = '.js-blog-carousel';

    private carouselWrapper: JQuery;
    private carousel: JQuery;
    private items: JQuery;
    private nextButton: JQuery;
    private prevButton: JQuery;
    private slick: JQuery;
    private numberOfSlidesToScroll: number;

    constructor(target: HTMLElement) {
        super(target);

        this.carouselWrapper = this.element.find('.blog-carousel__items-wrapper');
        this.carousel = this.element.find('.blog-carousel__items');
        this.items = this.element.find('.blog-carousel__item');
        this.prevButton = this.element.find('.blog-carousel__nav-button--prev');
        this.nextButton = this.element.find('.blog-carousel__nav-button--next');
        this.numberOfSlidesToScroll = 1;

        this.init();
    }

    init(): void {
        this.carousel.on('init', () => {
            this.onCarouselInit();
        });

        if (this.carouselWrapper.data('is-not-infinite')) {
            this.carousel.on('beforeChange', (event: JQuery.TriggeredEvent, slick: JQuery, currentSlide: number, nextSlide: number) => {
                this.disableButtons(currentSlide, nextSlide);
            });
        }

        if (window.matchMedia('(max-width: ' + Helpers.bp.sm + 'px)').matches && this.carouselWrapper.data('slides-to-scroll')) {
            this.numberOfSlidesToScroll = this.carouselWrapper.data('slides-to-scroll');
        }

        const carouselAttributes: JQuerySlickOptions = {
            arrows: false,
            infinite: !this.carouselWrapper.data('is-not-infinite'),
            slidesToScroll: this.numberOfSlidesToScroll,
            variableWidth: true,
            rows: 0,
        };

        this.slick = this.carousel.slick(carouselAttributes);
    }

    disableButtons(currentSlide: number, nextSlide: number): void {
        if (nextSlide === 0) {
            this.prevButton.addClass('blog-carousel__nav-button--disabled');
        } else {
            this.prevButton.removeClass('blog-carousel__nav-button--disabled');
        }

        if (nextSlide === this.items.length - 1) {
            this.nextButton.addClass('blog-carousel__nav-button--disabled');
        } else {
            this.nextButton.removeClass('blog-carousel__nav-button--disabled');
        }
    }

    onCarouselInit(): void {
        this.prevButton.on('click', this.onPrevClick.bind(this));
        this.nextButton.on('click', this.onNextClick.bind(this));
    }

    onPrevClick(): void {
        this.slick.slick('slickPrev');
    }

    onNextClick(): void {
        this.slick.slick('slickNext');
    }
}
